import { render, staticRenderFns } from "./CeremonyComponent.vue?vue&type=template&id=051f1b00&scoped=true&"
import script from "./CeremonyComponent.vue?vue&type=script&lang=js&"
export * from "./CeremonyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f1b00",
  null
  
)

export default component.exports